<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="$t('views.bulletin_creation.select_file')"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    size="md"
    body-class="file-selection"
    @hidden="hideModal"
  >
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
      @click:row="selectFile"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ $moment.utc(item.createdAt).format('L LT') }}
      </template>
    </v-data-table>
  </b-modal>
</template>

<script>
export default {
  name: 'FileSelection',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isShown: false,

      items: [],
      options: {},
      total: 0,
      loading: false,

      headers: [
        { text: this.$t('views.file_list.file'), value: 'name' },
        { text: this.$t('views.file_list.description'), value: 'description' },
        { text: this.$t('common.date'), value: 'createdAt' },
      ],
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
    },

    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    hideModal() {
      this.$emit('input', false);
    },

    async getItems() {
      this.loading = true;
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = {};
      params.pageSize = itemsPerPage;
      params.page = page;
      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      try {
        const { data = {} } = await this.$http.get('/files', { params });
        this.items = (data.rows || []).map((item) => ({
          ...item,
          createdAt: new Date(item.createdAt),
        }));
        this.total = data.total;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    selectFile(item) {
      this.$emit('addFromCatalog', item);
    },
  },
};
</script>

<style lang="scss">
.file-selection {
  .v-data-footer {
    padding-top: 15px;

    &__select {
      margin-right: 20px;

      .v-input {
        margin-left: 20px;
      }
    }

    &__pagination {
      margin-right: 20px;
    }
  }
}
</style>
